import React from "react";
import { Chart } from "react-google-charts";
import PropTypes from "prop-types";
import Config from "conFig.js";
const Vantaihanhkhach = React.memo(function Vantaihanhkhach(props) {
  const { thangnam } = props;
  const [buyt, setBuyt] = React.useState(0);
  const [taxi, setTaxi] = React.useState(0);
  const [tuyencodinh, setTuyencodinh] = React.useState(0);
  const [xedulich, setXedulich] = React.useState(0);
  const [xehopdong, setXehopdong] = React.useState(0);
  const [xedien, setXedien] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getvantaihanhkhach = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashvantaihanhkhach?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBuyt(data[0].buyt);
        setTaxi(data[0].taxi);
        setTuyencodinh(data[0].tuyencodinh);
        setXedulich(data[0].xedulich);
        setXehopdong(data[0].xedulich);
        setXedien(data[0].xedien);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const data = [
    ["Task", "Tỷ lệ"],
    ["Taxi (" + taxi + " chiếc)", parseInt(taxi)],
    ["Xe du lịch (" + xedulich + " chiếc)", parseInt(xedulich)],
    ["Xe hợp đồng (" + xehopdong + " chiếc)", parseInt(xehopdong)],
    ["Xe buýt (" + buyt + " chiếc)", parseInt(buyt)],
    ["Xe tuyến cố định (" + tuyencodinh + " chiếc)", parseInt(tuyencodinh)],
    ["Xe điện (" + xedien + " chiếc)", parseInt(xedien)],
  ];
  React.useEffect(() => {
    getvantaihanhkhach();
  }, [thangnam]);
  return (
    <Chart
      chartType="PieChart"
      loader={<div>Loading</div>}
      data={data}
      height="99%"
      options={{
        chartArea: {
          //marginTop: "-30px",
          width: "97%",
          height: "90%",
        },
        animation: {
          startup: true,
          easing: "linear",
          duration: 800,
        },
        backgroundColor: "transparent",
        hAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        vAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        legend: {
          textStyle: {
            color: "#ffffff",
          },
          position: "left",
        },
        titleTextStyle: {
          color: "#ffffff",
        },
      }}
    />
  );
});

Vantaihanhkhach.propTypes = {
  thangnam: PropTypes.object,
};
export default Vantaihanhkhach;
